const OFFSET_BETWEEN_MODALS = 24;
const MODAL_DEPTH_SCALE_FACTOR = 0.9;
const MODAL_DEPTH_FADE_FACTOR = 0.2;

interface ModalStackOverlayProps {
  stackCount: number;
  width: number;
  isGrowing: boolean;
}

export const ModalStackOverlay = ({ stackCount, isGrowing }: ModalStackOverlayProps) => {
  const renderCount = isGrowing ? stackCount - 1 : stackCount;

  return (
    <div
      className="relative z-0 flex w-full flex-col-reverse items-center transition-[margin]"
      style={{ marginTop: -OFFSET_BETWEEN_MODALS * renderCount }}
    >
      {Array.from({ length: renderCount }, (_, index) => {
        const depth = index + 1;
        const prevDepthWidth = `${MODAL_DEPTH_SCALE_FACTOR ** (depth - 1) * 100}%`;
        const currentDepthWidth = `${MODAL_DEPTH_SCALE_FACTOR ** depth * 100}%`;
        const prevDepthOpacity = Math.max(0, (depth - 1) * MODAL_DEPTH_FADE_FACTOR);
        const currentDepthOpacity = Math.max(0, depth * MODAL_DEPTH_FADE_FACTOR);

        return (
          <div
            key={depth}
            data-state={isGrowing ? "growing" : "shrinking"}
            className="relative w-full overscroll-contain bg-gray-400 data-[state=growing]:animate-[modal-overlay-enter_0.1s_linear] data-[state=shrinking]:animate-[modal-overlay-leave_0.1s_linear_forwards]"
            style={
              {
                maxWidth: currentDepthWidth,
                height: OFFSET_BETWEEN_MODALS,
                opacity: currentDepthOpacity,
                "--prev-depth-width": prevDepthWidth,
                "--current-depth-width": currentDepthWidth,
                "--prev-depth-opacity": prevDepthOpacity,
                "--current-depth-opacity": currentDepthOpacity,
                "--offset-between-modals": `${OFFSET_BETWEEN_MODALS}px`,
              } as React.CSSProperties
            }
          >
            <div
              className="bg-gray-50 transition-opacity"
              style={{
                opacity: currentDepthOpacity,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
